import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { pillars } from '../../data/content';
export function NewWay() {
  return <section className="bg-white px-5 py-16 sm:py-24" data-id="element-227" data-mp="3njgpx4dyof2m">
      <div className="mx-auto max-w-3xl" data-id="element-228" data-mp="3imq7iaeop7e1">
        <SectionHeading eyebrow="7 days · 15 minutes a day" title="A New Way to Begin Your Apometry Practice" data-id="element-229" data-mp="3ilwzz77widuu" />
        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-230" data-mp="3eiijkfg1vvgv">
          <p data-id="element-231" data-mp="39nlbpbuibs5k">
            For a long time, when someone became interested in Apometry, it seemed like the only option was to study
            hundreds of pages, learn numerous techniques and spend months trying to understand how to put all that
            knowledge into practice.
          </p>
          <p className="font-semibold text-ink" data-id="element-232" data-mp="12sydafwa1e3x">But many people don’t need to start there.</p>
          <p data-id="element-233" data-mp="xwr32awulgg6">First, they need something much simpler:</p>
        </div>
        <p className="my-8 border-l-4 border-brand-600 pl-5 font-display text-3xl font-bold italic text-brand-700 sm:text-4xl" data-id="element-234" data-mp="2grp4k4j1xq1c">
          to know what to do.
        </p>
        <p className="text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-235" data-mp="26usw1yt5l3ws">
          That’s why I created the <strong className="text-ink" data-id="element-236" data-mp="2bt4547bmjady">7D Apometry Protocol™</strong> — a practical path that
          organizes a 7-day experience around five pillars:
        </p>
      </div>

      <ol className="mx-auto mt-10 flex max-w-5xl flex-col items-stretch gap-2 md:flex-row md:items-center" data-id="element-237" data-mp="2zlkr2syhfmij">
        {pillars.map((pillar, i) => <li key={pillar} className="flex flex-col items-center gap-2 md:flex-1 md:flex-row" data-id="element-238" data-mp="2psdiz0ccxser" data-mpi={i}>
            <span className="flex w-full items-center justify-center gap-3 rounded-xl bg-brand-800 px-4 py-3.5 text-white" data-id="element-239" data-mp="2urgi645np4et">
              <span className="font-display text-lg font-bold text-gold" data-id="element-240" data-mp="3igrk3oyqt4uj">{i + 1}</span>
              <span className="text-base font-bold uppercase tracking-wider" data-id="element-241" data-mp="3nadnsrmxhye7">{pillar}</span>
            </span>
            {i < pillars.length - 1 && <>
                <ArrowDownIcon className="h-5 w-5 text-brand-400 md:hidden" aria-hidden="true" data-id="element-242" data-mp="3s5gcuzco2giw" />
                <ArrowRightIcon className="hidden h-5 w-5 shrink-0 text-brand-400 md:block" aria-hidden="true" data-id="element-243" data-mp="3o3bn4bpca41j" />
              </>}
          </li>)}
      </ol>

      <CtaButton label="I want a clear path to get started" className="mt-12" data-id="element-244" data-mp="3e5x90iqw1rce" />
    </section>;
}